export default __webpack_public_path__ + "static/realWorldImg1-0cdd0bcc1ad8fde14eb506b7d7025f56.png";